export const Marquee = ({ items, className = "" }) => {
    const row = items.join("  •  ") + "  •  ";
    return (
        <div data-testid="editorial-marquee" className={`overflow-hidden border-y border-white/5 py-6 ${className}`}>
            <div className="marquee-track flex whitespace-nowrap w-max">
                {[0, 1].map((i) => (
                    <span key={i} className="font-display italic text-2xl sm:text-3xl text-[#5C5A56] pr-4">
                        {row}
                    </span>
                ))}
            </div>
        </div>
    );
};
